<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";
export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["TabloId", "DonemId", "Sorgulama","BirimId","UstDonemId"],
  components: {
        Loader,
    },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Birimid: "",
      TableData: [],
      TableDataDetails: [],
      bugun: null,
      UstDonemAciklama: "",
      AltDonemler: {},
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId(){
      this.Get();
    }
  },

  methods: {
    DonemOrtalama(Donemindex) {
      var DonemToplam = 0;
      var AmacSayisi = 0;
      for (let i = 0; i < this.TableData.length; i++) {
        for (let j = 0; j < this.TableData[i].DonemPerformanslari.length; j++) {
        if (Donemindex == j){
          DonemToplam += this.TableData[i].DonemPerformanslari[j]
          AmacSayisi += 1
        }

        }
      }
      return (DonemToplam / AmacSayisi).toFixed(2);
    },
    Get() {

      this.bugun = new Date();
      this.TableData = [];
      this.TableDataDetails = [];
      let Filter = "&UstDonemId=" + this.UstDonemId + "&DonemId=" + this.DonemId + "&TabloId=" + this.TabloId;
      if(this.BirimId!=null && this.BirimId!=""){
        Filter=Filter+"&Birimid="+this.BirimId;
      }
      this.ActionsFilterGet({ Service: "StrRaporlama/GetStratejikPlanYillikGerceklesmeOranlariTablosu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;

      });

      

    },
    ExcelExport(table, name){  
                if (!table.nodeType) table = this.$refs.StratejikPlanYillikGerceklesmeOranlariTablosu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
    }, 




  },
  computed: {},

  created() {

      this.EskiDonem=[];
      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: this.UstDonemId,
              }).then((res) => {
                this.UstDonemAciklama = res.Data.Aciklama; 
                let Filter = "&UstId=" + res.Data.Id +"&VeriTipi=3" +"&Asc=sira";
                this.ActionsFilterGet({ Service: "strperfdonem", Page: this.Page, Filter: Filter}).then((res) => {
          this.AltDonemler = res.Data;
          this.Page.PageDataSize = res.TotalCount;

      });


      });
    this.Get();
  },
};
</script>
<template>
      <Loader>
        <div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="text-sm-end">
        <button
          type="button"
          class="btn btn-success btn-rounded mb-2 me-2"
          @click="ExcelExport('Stratejik Plan Değerlendirme Tablosu (Amaç Bazlı)', 'Stratejik Plan Değerlendirme Tablosu (Amaç Bazlı)')"
        >
          <i class="mdi mdi-file-export-outline me-1"></i>
          Excel'e Aktar
        </button>
      </div>

      <div ref="StratejikPlanYillikGerceklesmeOranlariTablosu" class="table-responsive">
        <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
          <tbody>
            <tr>
              <th style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" colspan="1">Dönem Adı</th>
              <th style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" colspan="1" v-for="(SubData, index) in this.AltDonemler" :key="index">{{SubData.Aciklama}}</th>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <th style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" colspan="1">{{ UstDonemAciklama }}</th>
              <th style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" colspan="1" v-for="(SubData, index) in this.AltDonemler" :key="index">{{ DonemOrtalama(index) }}</th>
            </tr>
          </tbody>
          <tbody v-for="(Data, index) in TableData" :key="index">
            <tr>
              <td style="background-color:rgb(7, 156, 165); font-weight: bold;" colspan="1">{{ Data.AmacAdi }}</td>
              <td style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" colspan="1" v-for="(DonemPerformanslari, index) in Data.DonemPerformanslari" :key="index"
              >{{ DonemPerformanslari | formatNoktaToVirgul }}</td>
            </tr>
            <tr v-for="(SubData, index) in Data.TabloDetay" :key="index">
              <td colspan="1">{{ SubData.HedefAdi }}**</td>
              <td colspan="1" style="text-align: center;" v-for="(Performans, index) in SubData.DonemPerformanslari" :key="index"
              >{{ Performans | formatNoktaToVirgul }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
    </div>
  </div>
</div>
</Loader>
</template>
